var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: -0.000244141,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#B0EAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.8506,
    y: -1.00024,
    width: 25,
    height: 46.9402,
    transform: "rotate(44.8428 33.8506 -1.00024)",
    fill: "#00B6CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_7909"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: -0.000244141,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.63826cc727018e5c82ec650548a69e39.svg";
export { ForwardRef as ReactComponent };